// extracted by mini-css-extract-plugin
module.exports = {"container":"content_placeholder_container__1HHjG","line":"content_placeholder_line__GgkD0","shimmer":"content_placeholder_shimmer__0zTdV"};